export type Country = {
  abbr: string
  code: string
  name: string
  suggested?: boolean
  continent?: string
}

export const allCountries: Country[] = [
  { name: 'Afghanistan', abbr: 'AF', code: '93', continent: 'Asia' },
  { name: 'Åland Islands', abbr: 'AX', code: '358', continent: 'Europe' },
  { name: 'Albania', abbr: 'AL', code: '355', continent: 'Europe' },
  { name: 'Algeria', abbr: 'DZ', code: '213', continent: 'Africa' },
  { name: 'American Samoa', abbr: 'AS', code: '1-684', continent: 'Oceania' },
  { name: 'Andorra', abbr: 'AD', code: '376', continent: 'Europe' },
  { name: 'Angola', abbr: 'AO', code: '244', continent: 'Africa' },
  { name: 'Anguilla', abbr: 'AI', code: '1-264', continent: 'North America' },
  { name: 'Antarctica', abbr: 'AQ', code: '672', continent: 'Antarctica' },
  { name: 'Antigua and Barbuda', abbr: 'AG', code: '1-268', continent: 'North America' },
  { name: 'Argentina', abbr: 'AR', code: '54', continent: 'South America' },
  { name: 'Armenia', abbr: 'AM', code: '374', continent: 'Asia' },
  { name: 'Aruba', abbr: 'AW', code: '297', continent: 'North America' },
  { name: 'Australia', abbr: 'AU', code: '61', continent: 'Oceania', suggested: true },
  { name: 'Austria', abbr: 'AT', code: '43', continent: 'Europe' },
  { name: 'Azerbaijan', abbr: 'AZ', code: '994', continent: 'Asia' },
  { name: 'Bahamas', abbr: 'BS', code: '1-242', continent: 'North America' },
  { name: 'Bahrain', abbr: 'BH', code: '973', continent: 'Asia' },
  { name: 'Bangladesh', abbr: 'BD', code: '880', continent: 'Asia' },
  { name: 'Barbados', abbr: 'BB', code: '1-246', continent: 'North America' },
  { name: 'Belarus', abbr: 'BY', code: '375', continent: 'Europe' },
  { name: 'Belgium', abbr: 'BE', code: '32', continent: 'Europe' },
  { name: 'Belize', abbr: 'BZ', code: '501', continent: 'North America' },
  { name: 'Benin', abbr: 'BJ', code: '229', continent: 'Africa' },
  { name: 'Bermuda', abbr: 'BM', code: '1-441', continent: 'North America' },
  { name: 'Bhutan', abbr: 'BT', code: '975', continent: 'Asia' },
  { name: 'Bolivia', abbr: 'BO', code: '591', continent: 'South America' },
  { name: 'Bosnia and Herzegovina', abbr: 'BA', code: '387', continent: 'Europe' },
  { name: 'Botswana', abbr: 'BW', code: '267', continent: 'Africa' },
  { name: 'Bouvet Island', abbr: 'BV', code: '47', continent: 'Antarctica' },
  { name: 'Brazil', abbr: 'BR', code: '55', continent: 'South America' },
  { name: 'British Indian Ocean Territory', abbr: 'IO', code: '246', continent: 'Asia' },
  { name: 'British Virgin Islands', abbr: 'VG', code: '1-284', continent: 'North America' },
  { name: 'Brunei Darussalam', abbr: 'BN', code: '673', continent: 'Asia' },
  { name: 'Bulgaria', abbr: 'BG', code: '359', continent: 'Europe' },
  { name: 'Burkina Faso', abbr: 'BF', code: '226', continent: 'Africa' },
  { name: 'Burundi', abbr: 'BI', code: '257', continent: 'Africa' },
  { name: 'Cambodia', abbr: 'KH', code: '855', continent: 'Asia' },
  { name: 'Cameroon', abbr: 'CM', code: '237', continent: 'Africa' },
  { name: 'Canada', abbr: 'CA', code: '1', continent: 'North America', suggested: true },
  { name: 'Cape Verde', abbr: 'CV', code: '238', continent: 'Africa' },
  { name: 'Cayman Islands', abbr: 'KY', code: '1-345', continent: 'North America' },
  { name: 'Central African Republic', abbr: 'CF', code: '236', continent: 'Africa' },
  { name: 'Chad', abbr: 'TD', code: '235', continent: 'Africa' },
  { name: 'Chile', abbr: 'CL', code: '56', continent: 'South America' },
  { name: 'China', abbr: 'CN', code: '86', continent: 'Asia' },
  { name: 'Christmas Island', abbr: 'CX', code: '61', continent: 'Asia' },
  { name: 'Cocos (Keeling) Islands', abbr: 'CC', code: '61', continent: 'Asia' },
  { name: 'Colombia', abbr: 'CO', code: '57', continent: 'South America' },
  { name: 'Comoros', abbr: 'KM', code: '269', continent: 'Africa' },
  { name: 'Congo, Democratic Republic of the', abbr: 'CG', code: '243', continent: 'Africa' },
  { name: 'Congo, Republic of the', abbr: 'CD', code: '242', continent: 'Africa' },
  { name: 'Cook Islands', abbr: 'CK', code: '682', continent: 'Oceania' },
  { name: 'Costa Rica', abbr: 'CR', code: '506', continent: 'North America' },
  { name: "Côte d'Ivoire", abbr: 'CI', code: '225', continent: 'Africa' },
  { name: 'Croatia', abbr: 'HR', code: '385', continent: 'Europe' },
  { name: 'Cuba', abbr: 'CU', code: '53', continent: 'North America' },
  { name: 'Cyprus', abbr: 'CY', code: '357', continent: 'Asia' },
  { name: 'Czech Republic', abbr: 'CZ', code: '420', continent: 'Europe' },
  { name: 'Denmark', abbr: 'DK', code: '45', continent: 'Europe' },
  { name: 'Djibouti', abbr: 'DJ', code: '253', continent: 'Africa' },
  { name: 'Dominica', abbr: 'DM', code: '1-767', continent: 'North America' },
  {
    name: 'Dominican Republic',
    abbr: 'DO',
    code: '1-809, 1-829, 1-849',
    continent: 'North America',
  },
  { name: 'Ecuador', abbr: 'EC', code: '593', continent: 'South America' },
  { name: 'Egypt', abbr: 'EG', code: '20', continent: 'Africa' },
  { name: 'El Salvador', abbr: 'SV', code: '503', continent: 'North America' },
  { name: 'Equatorial Guinea', abbr: 'GQ', code: '240', continent: 'Africa' },
  { name: 'Eritrea', abbr: 'ER', code: '291', continent: 'Africa' },
  { name: 'Estonia', abbr: 'EE', code: '372', continent: 'Europe' },
  { name: 'Eswatini', abbr: 'SZ', code: '268', continent: 'Africa' },
  { name: 'Ethiopia', abbr: 'ET', code: '251', continent: 'Africa' },
  { name: 'Falkland Islands (Malvinas)', abbr: 'FK', code: '500', continent: 'South America' },
  { name: 'Faroe Islands', abbr: 'FO', code: '298', continent: 'Europe' },
  { name: 'Fiji', abbr: 'FJ', code: '679', continent: 'Oceania' },
  { name: 'Finland', abbr: 'FI', code: '358', continent: 'Europe' },
  { name: 'France', abbr: 'FR', code: '33', continent: 'Europe' },
  { name: 'French Guiana', abbr: 'GF', code: '594', continent: 'South America' },
  { name: 'French Polynesia', abbr: 'PF', code: '689', continent: 'Oceania' },
  { name: 'Gabon', abbr: 'GA', code: '241', continent: 'Africa' },
  { name: 'Gambia', abbr: 'GM', code: '220', continent: 'Africa' },
  { name: 'Georgia', abbr: 'GE', code: '995', continent: 'Asia' },
  { name: 'Germany', abbr: 'DE', code: '49', continent: 'Europe' },
  { name: 'Ghana', abbr: 'GH', code: '233', continent: 'Africa' },
  { name: 'Gibraltar', abbr: 'GI', code: '350', continent: 'Europe' },
  { name: 'Greece', abbr: 'GR', code: '30', continent: 'Europe' },
  { name: 'Greenland', abbr: 'GL', code: '299', continent: 'North America' },
  { name: 'Grenada', abbr: 'GD', code: '1-473', continent: 'North America' },
  { name: 'Guadeloupe', abbr: 'GP', code: '590', continent: 'North America' },
  { name: 'Guam', abbr: 'GU', code: '1-671', continent: 'Oceania' },
  { name: 'Guatemala', abbr: 'GT', code: '502', continent: 'North America' },
  { name: 'Guernsey', abbr: 'GG', code: '44-1481', continent: 'Europe' },
  { name: 'Guinea', abbr: 'GN', code: '224', continent: 'Africa' },
  { name: 'Guinea-Bissau', abbr: 'GW', code: '245', continent: 'Africa' },
  { name: 'Guyana', abbr: 'GY', code: '592', continent: 'South America' },
  { name: 'Haiti', abbr: 'HT', code: '509', continent: 'North America' },
  { name: 'Heard Island and McDonald Islands', abbr: 'HM', code: '', continent: 'Antarctica' },
  { name: 'Holy See (Vatican City State)', abbr: 'VA', code: '379', continent: 'Europe' },
  { name: 'Honduras', abbr: 'HN', code: '504', continent: 'North America' },
  { name: 'Hong Kong', abbr: 'HK', code: '852', continent: 'Asia' },
  { name: 'Hungary', abbr: 'HU', code: '36', continent: 'Europe' },
  { name: 'Iceland', abbr: 'IS', code: '354', continent: 'Europe' },
  { name: 'India', abbr: 'IN', code: '91', continent: 'Asia' },
  { name: 'Indonesia', abbr: 'ID', code: '62', continent: 'Asia' },
  { name: 'Iran, Islamic Republic of', abbr: 'IR', code: '98', continent: 'Asia' },
  { name: 'Iraq', abbr: 'IQ', code: '964', continent: 'Asia' },
  { name: 'Ireland', abbr: 'IE', code: '353', continent: 'Europe' },
  { name: 'Isle of Man', abbr: 'IM', code: '44-1624', continent: 'Europe' },
  { name: 'Israel', abbr: 'IL', code: '972', continent: 'Asia' },
  { name: 'Italy', abbr: 'IT', code: '39', continent: 'Europe' },
  { name: 'Jamaica', abbr: 'JM', code: '1-876', continent: 'North America' },
  { name: 'Japan', abbr: 'JP', code: '81', continent: 'Asia' },
  { name: 'Jersey', abbr: 'JE', code: '44-1534', continent: 'Europe' },
  { name: 'Jordan', abbr: 'JO', code: '962', continent: 'Asia' },
  { name: 'Kazakhstan', abbr: 'KZ', code: '7', continent: 'Asia' },
  { name: 'Kenya', abbr: 'KE', code: '254', continent: 'Africa' },
  { name: 'Kiribati', abbr: 'KI', code: '686', continent: 'Oceania' },
  { name: "Korea, Democratic People's Republic of", abbr: 'KP', code: '850', continent: 'Asia' },
  { name: 'Korea, Republic of', abbr: 'KR', code: '82', continent: 'Asia' },
  { name: 'Kuwait', abbr: 'KW', code: '965', continent: 'Asia' },
  { name: 'Kyrgyzstan', abbr: 'KG', code: '996', continent: 'Asia' },
  { name: "Lao People's Democratic Republic", abbr: 'LA', code: '856', continent: 'Asia' },
  { name: 'Latvia', abbr: 'LV', code: '371', continent: 'Europe' },
  { name: 'Lebanon', abbr: 'LB', code: '961', continent: 'Asia' },
  { name: 'Lesotho', abbr: 'LS', code: '266', continent: 'Africa' },
  { name: 'Liberia', abbr: 'LR', code: '231', continent: 'Africa' },
  { name: 'Libyan Arab Jamahiriya', abbr: 'LY', code: '218', continent: 'Africa' },
  { name: 'Liechtenstein', abbr: 'LI', code: '423', continent: 'Europe' },
  { name: 'Lithuania', abbr: 'LT', code: '370', continent: 'Europe' },
  { name: 'Luxembourg', abbr: 'LU', code: '352', continent: 'Europe' },
  { name: 'Macao', abbr: 'MO', code: '853', continent: 'Asia' },
  { name: 'North Macedonia', abbr: 'MK', code: '389', continent: 'Europe' },
  { name: 'Madagascar', abbr: 'MG', code: '261', continent: 'Africa' },
  { name: 'Malawi', abbr: 'MW', code: '265', continent: 'Africa' },
  { name: 'Malaysia', abbr: 'MY', code: '60', continent: 'Asia' },
  { name: 'Maldives', abbr: 'MV', code: '960', continent: 'Asia' },
  { name: 'Mali', abbr: 'ML', code: '223', continent: 'Africa' },
  { name: 'Malta', abbr: 'MT', code: '356', continent: 'Europe' },
  { name: 'Marshall Islands', abbr: 'MH', code: '692', continent: 'Oceania' },
  { name: 'Martinique', abbr: 'MQ', code: '596', continent: 'North America' },
  { name: 'Mauritania', abbr: 'MR', code: '222', continent: 'Africa' },
  { name: 'Mauritius', abbr: 'MU', code: '230', continent: 'Africa' },
  { name: 'Mayotte', abbr: 'YT', code: '262', continent: 'Africa' },
  { name: 'Mexico', abbr: 'MX', code: '52', continent: 'North America' },
  { name: 'Micronesia, Federated States of', abbr: 'FM', code: '691', continent: 'Oceania' },
  { name: 'Moldova, Republic of', abbr: 'MD', code: '373', continent: 'Europe' },
  { name: 'Monaco', abbr: 'MC', code: '377', continent: 'Europe' },
  { name: 'Mongolia', abbr: 'MN', code: '976', continent: 'Asia' },
  { name: 'Montenegro', abbr: 'ME', code: '382', continent: 'Europe' },
  { name: 'Montserrat', abbr: 'MS', code: '1-664', continent: 'North America' },
  { name: 'Morocco', abbr: 'MA', code: '212', continent: 'Africa' },
  { name: 'Mozambique', abbr: 'MZ', code: '258', continent: 'Africa' },
  { name: 'Myanmar', abbr: 'MM', code: '95', continent: 'Asia' },
  { name: 'Namibia', abbr: 'NA', code: '264', continent: 'Africa' },
  { name: 'Nauru', abbr: 'NR', code: '674', continent: 'Oceania' },
  { name: 'Nepal', abbr: 'NP', code: '977', continent: 'Asia' },
  { name: 'Netherlands', abbr: 'NL', code: '31', continent: 'Europe' },
  { name: 'Netherlands Antilles', abbr: 'AN', code: '599', continent: 'North America' },
  { name: 'New Caledonia', abbr: 'NC', code: '687', continent: 'Oceania' },
  { name: 'New Zealand', abbr: 'NZ', code: '64', continent: 'Oceania' },
  { name: 'Nicaragua', abbr: 'NI', code: '505', continent: 'North America' },
  { name: 'Niger', abbr: 'NE', code: '227', continent: 'Africa' },
  { name: 'Nigeria', abbr: 'NG', code: '234', continent: 'Africa' },
  { name: 'Niue', abbr: 'NU', code: '683', continent: 'Oceania' },
  { name: 'Norfolk Island', abbr: 'NF', code: '672', continent: 'Oceania' },
  { name: 'Northern Mariana Islands', abbr: 'MP', code: '1-670', continent: 'Oceania' },
  { name: 'Norway', abbr: 'NO', code: '47', continent: 'Europe' },
  { name: 'Oman', abbr: 'OM', code: '968', continent: 'Asia' },
  { name: 'Pakistan', abbr: 'PK', code: '92', continent: 'Asia' },
  { name: 'Palau', abbr: 'PW', code: '680', continent: 'Oceania' },
  { name: 'Palestinian Territory, Occupied', abbr: 'PS', code: '970', continent: 'Asia' },
  { name: 'Panama', abbr: 'PA', code: '507', continent: 'North America' },
  { name: 'Papua New Guinea', abbr: 'PG', code: '675', continent: 'Oceania' },
  { name: 'Paraguay', abbr: 'PY', code: '595', continent: 'South America' },
  { name: 'Peru', abbr: 'PE', code: '51', continent: 'South America' },
  { name: 'Philippines', abbr: 'PH', code: '63', continent: 'Asia' },
  { name: 'Pitcairn', abbr: 'PN', code: '870', continent: 'Oceania' },
  { name: 'Poland', abbr: 'PL', code: '48', continent: 'Europe' },
  { name: 'Portugal', abbr: 'PT', code: '351', continent: 'Europe' },
  { name: 'Puerto Rico', abbr: 'PR', code: '1-787, 1-939', continent: 'North America' },
  { name: 'Qatar', abbr: 'QA', code: '974', continent: 'Asia' },
  { name: 'Réunion', abbr: 'RE', code: '262', continent: 'Africa' },
  { name: 'Romania', abbr: 'RO', code: '40', continent: 'Europe' },
  { name: 'Russian Federation', abbr: 'RU', code: '7', continent: 'Europe' },
  { name: 'Rwanda', abbr: 'RW', code: '250', continent: 'Africa' },
  { name: 'Saint Barthélemy', abbr: 'BL', code: '590', continent: 'North America' },
  { name: 'Saint Helena', abbr: 'SH', code: '290', continent: 'Africa' },
  { name: 'Saint Kitts and Nevis', abbr: 'KN', code: '1-869', continent: 'North America' },
  { name: 'Saint Lucia', abbr: 'LC', code: '1-758', continent: 'North America' },
  { name: 'Saint Martin (French part)', abbr: 'MF', code: '590', continent: 'North America' },
  { name: 'Saint Pierre and Miquelon', abbr: 'PM', code: '508', continent: 'North America' },
  {
    name: 'Saint Vincent and the Grenadines',
    abbr: 'VC',
    code: '1-784',
    continent: 'North America',
  },
  { name: 'Samoa', abbr: 'WS', code: '685', continent: 'Oceania' },
  { name: 'San Marino', abbr: 'SM', code: '378', continent: 'Europe' },
  { name: 'Sao Tome and Principe', abbr: 'ST', code: '239', continent: 'Africa' },
  { name: 'Saudi Arabia', abbr: 'SA', code: '966', continent: 'Asia' },
  { name: 'Senegal', abbr: 'SN', code: '221', continent: 'Africa' },
  { name: 'Serbia', abbr: 'RS', code: '381', continent: 'Europe' },
  { name: 'Seychelles', abbr: 'SC', code: '248', continent: 'Africa' },
  { name: 'Sierra Leone', abbr: 'SL', code: '232', continent: 'Africa' },
  { name: 'Singapore', abbr: 'SG', code: '65', continent: 'Asia' },
  { name: 'Slovakia', abbr: 'SK', code: '421', continent: 'Europe' },
  { name: 'Slovenia', abbr: 'SI', code: '386', continent: 'Europe' },
  { name: 'Solomon Islands', abbr: 'SB', code: '677', continent: 'Oceania' },
  { name: 'Somalia', abbr: 'SO', code: '252', continent: 'Africa' },
  { name: 'South Africa', abbr: 'ZA', code: '27', continent: 'Africa' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    abbr: 'GS',
    code: '',
    continent: 'Antarctica',
  },
  { name: 'South Sudan', abbr: 'SS', code: '211', continent: 'Africa' },
  { name: 'Spain', abbr: 'ES', code: '34', continent: 'Europe' },
  { name: 'Sri Lanka', abbr: 'LK', code: '94', continent: 'Asia' },
  { name: 'Sudan', abbr: 'SD', code: '249', continent: 'Africa' },
  { name: 'Suriname', abbr: 'SR', code: '597', continent: 'South America' },
  { name: 'Svalbard and Jan Mayen', abbr: 'SJ', code: '47', continent: 'Europe' },
  { name: 'Sweden', abbr: 'SE', code: '46', continent: 'Europe' },
  { name: 'Switzerland', abbr: 'CH', code: '41', continent: 'Europe' },
  { name: 'Syrian Arab Republic', abbr: 'SY', code: '963', continent: 'Asia' },
  { name: 'Taiwan, Province of China', abbr: 'TW', code: '886', continent: 'Asia' },
  { name: 'Tajikistan', abbr: 'TJ', code: '992', continent: 'Asia' },
  { name: 'Tanzania, United Republic of', abbr: 'TZ', code: '255', continent: 'Africa' },
  { name: 'Thailand', abbr: 'TH', code: '66', continent: 'Asia' },
  { name: 'Timor-Leste', abbr: 'TL', code: '670', continent: 'Asia' },
  { name: 'Togo', abbr: 'TG', code: '228', continent: 'Africa' },
  { name: 'Tokelau', abbr: 'TK', code: '690', continent: 'Oceania' },
  { name: 'Tonga', abbr: 'TO', code: '676', continent: 'Oceania' },
  { name: 'Trinidad and Tobago', abbr: 'TT', code: '1-868', continent: 'North America' },
  { name: 'Tunisia', abbr: 'TN', code: '216', continent: 'Africa' },
  { name: 'Turkey', abbr: 'TR', code: '90', continent: 'Europe' },
  { name: 'Turkmenistan', abbr: 'TM', code: '993', continent: 'Asia' },
  { name: 'Turks and Caicos Islands', abbr: 'TC', code: '1-649', continent: 'North America' },
  { name: 'Tuvalu', abbr: 'TV', code: '688', continent: 'Oceania' },
  { name: 'Uganda', abbr: 'UG', code: '256', continent: 'Africa' },
  { name: 'Ukraine', abbr: 'UA', code: '380', continent: 'Europe' },
  { name: 'United Arab Emirates', abbr: 'AE', code: '971', continent: 'Asia' },
  { name: 'United Kingdom', abbr: 'GB', code: '44', continent: 'Europe' },
  { name: 'United States', abbr: 'US', code: '1', continent: 'North America', suggested: true },
  { name: 'United States Minor Outlying Islands', abbr: 'UM', code: '1', continent: 'Oceania' },
  { name: 'Uruguay', abbr: 'UY', code: '598', continent: 'South America' },
  { name: 'Uzbekistan', abbr: 'UZ', code: '998', continent: 'Asia' },
  { name: 'Vanuatu', abbr: 'VU', code: '678', continent: 'Oceania' },
  { name: 'Venezuela, Bolivarian Republic of', abbr: 'VE', code: '58', continent: 'South America' },
  { name: 'Viet Nam', abbr: 'VN', code: '84', continent: 'Asia' },
  { name: 'Virgin Islands, British', abbr: 'VG', code: '1-284', continent: 'North America' },
  { name: 'Virgin Islands, U.S.', abbr: 'VI', code: '1-340', continent: 'North America' },
  { name: 'Wallis and Futuna', abbr: 'WF', code: '681', continent: 'Oceania' },
  { name: 'Western Sahara', abbr: 'EH', code: '212', continent: 'Africa' },
  { name: 'Yemen', abbr: 'YE', code: '967', continent: 'Asia' },
  { name: 'Zambia', abbr: 'ZM', code: '260', continent: 'Africa' },
  { name: 'Zimbabwe', abbr: 'ZW', code: '263', continent: 'Africa' },
]

export const allCountryNames = allCountries.map((country) => country.name)

export const getCountryAbbrByName = (name: string) => {
  return allCountries.find((country) => country.name == name)?.abbr
}

export const getContinentByCountryName = (name: string): string | undefined => {
  return allCountries.find((country) => country.name == name)?.continent
}
